<template>
  <div class="img-zoom-wrapper" ref="wrap">
    <zoom-on-hover
      :key="`${src}-${resolvedScale}`"
      :img-normal="src"
      :img-zoom="zoomSrc || src"
      :scale="resolvedScale"
      class="zoom-container"
    />
  </div>
</template>

<script>
export default {
  name: 'ImgZoomable',
  props: {
    src: { type: String, required: true },
    zoomSrc: { type: String, default: null },
    // Magnification relative to the displayed image (library uses parseInt)
    scale: { type: Number, default: 2 }
  },
  data() {
    return {
      resolvedScale: 2
    };
  },
  mounted() {
    this.computeScale();
  },
  watch: {
    src() { this.computeScale(); },
    zoomSrc() { this.computeScale(); },
    scale() { this.computeScale(); }
  },
  methods: {
    computeScale() {
      // vue-zoom-on-hover applies parseInt on scale; keep an integer >= 1
      this.resolvedScale = Math.max(1, Math.round(Number(this.scale) || 1));
    }
  }
}
</script>

<style scoped>
.img-zoom-wrapper { width: 100%; }
.zoom-container { display: block; width: 100%; }

/*
  By default vue-zoom-on-hover shows the zoom layer at natural pixel size,
  so even scale=1 looks hugely magnified. Match the displayed width instead
  so :scale="2" means a true 2x of what the user sees.
*/
.img-zoom-wrapper ::v-deep .zoom {
  width: 100%;
}
</style>
